import { useEffect, useLayoutEffect } from 'react';

/**
 * useLayoutEffect in a browser, useEffect where there is no document (a server render, such as the
 * specs' renderToStaticMarkup). React logs a warning for every useLayoutEffect it meets on the server,
 * and several page specs fail on any console error; on the server neither effect runs anyway.
 */
export const useIsoLayoutEffect = typeof document === 'undefined' ? useEffect : useLayoutEffect;
